import { io, Socket } from 'socket.io-client';
import { env } from '../env';

const API_BASE_URL = env.REACT_APP_API_URL || 'http://127.0.0.1:5001';
const SOCKET_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

let socket: Socket | null = null;
let socketToken: string | null = null;
const joinedThreadIds = new Set<number>();

const getToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem('token');
};

export const connectAdvisorSocket = (): Socket | null => {
  const token = getToken();
  if (!token) {
    if (socket) {
      socket.disconnect();
      socket = null;
      socketToken = null;
      joinedThreadIds.clear();
    }
    return null;
  }
  if (socket && socketToken && socketToken !== token) {
    socket.disconnect();
    socket = null;
    socketToken = null;
    joinedThreadIds.clear();
  }
  if (socket) {
    if (!socket.connected) socket.connect();
    return socket;
  }
  socketToken = token;
  socket = io(SOCKET_BASE_URL, {
    transports: ['websocket', 'polling'],
    withCredentials: true,
    auth: { token },
    autoConnect: true,
    reconnection: true,
  });
  socket.on('connect', () => {
    joinedThreadIds.forEach((threadId) => {
      socket?.emit('chat:join_thread', { thread_id: threadId });
    });
  });
  return socket;
};

export const joinAdvisorThreadRoom = (threadId: number, ack?: (response: any) => void) => {
  joinedThreadIds.add(threadId);
  const client = connectAdvisorSocket();
  if (!client) return;
  if (ack) {
    client.emit('chat:join_thread', { thread_id: threadId }, ack);
    return;
  }
  client.emit('chat:join_thread', { thread_id: threadId });
};

export const leaveAdvisorThreadRoom = (threadId: number) => {
  joinedThreadIds.delete(threadId);
  if (!socket) return;
  socket.emit('chat:leave_thread', { thread_id: threadId });
};

export const onAdvisorMessageEvent = (handler: (payload: any) => void) => {
  const client = connectAdvisorSocket();
  if (!client) return () => {};
  client.on('chat:new', handler);
  return () => client.off('chat:new', handler);
};

export const onAdvisorThreadUpdatedEvent = (handler: (payload: any) => void) => {
  const client = connectAdvisorSocket();
  if (!client) return () => {};
  client.on('chat:thread_updated', handler);
  return () => client.off('chat:thread_updated', handler);
};

export const emitAdvisorTyping = (threadId: number, ack?: (response: any) => void) => {
  const client = connectAdvisorSocket();
  if (!client) return;
  if (ack) {
    client.emit('chat:typing', { thread_id: threadId }, ack);
    return;
  }
  client.emit('chat:typing', { thread_id: threadId });
};

export const emitAdvisorStopTyping = (threadId: number, ack?: (response: any) => void) => {
  const client = connectAdvisorSocket();
  if (!client) return;
  if (ack) {
    client.emit('chat:stop_typing', { thread_id: threadId }, ack);
    return;
  }
  client.emit('chat:stop_typing', { thread_id: threadId });
};

export const onAdvisorTypingEvent = (handler: (payload: any) => void) => {
  const client = connectAdvisorSocket();
  if (!client) return () => {};
  client.on('chat:typing', handler);
  return () => client.off('chat:typing', handler);
};

export const onAdvisorStopTypingEvent = (handler: (payload: any) => void) => {
  const client = connectAdvisorSocket();
  if (!client) return () => {};
  client.on('chat:stop_typing', handler);
  return () => client.off('chat:stop_typing', handler);
};
